import React from 'react';
import styles from './PageHero.module.scss';
import Carousel from 'react-bootstrap/Carousel'

const PageHero = ({ data }) => {

 const isMultipleImages = data.images.length > 1;

  return  (
    <div className={styles['PageHero']}>
      <div className={styles.carousel}>
        <Carousel controls={false} indicators={isMultipleImages} interval={null}>
          {data.images.map(image => {
            return (
              <Carousel.Item key={image._id} style={{ height: '100vh' }}>
                <img className={styles['feature-image']} src={image.url} alt={image.title}/>
              </Carousel.Item>
            );
          })}
        </Carousel>
      </div>
      <div className={styles.content}>
        <h2 className={styles.header}>
          <b>{data.header}</b>
        </h2>
        <p className={styles.description}>
          {data.description}
        </p>
      </div>
    </div>
  );
};

export default PageHero;